export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

export const CONTACT_US_URL = `${BASE_URL}/${API_VERSION}/vantage/landing/contact-us`;
